import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InnerHeaderComponent } from './inner-header.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';



@NgModule({
  declarations: [
    InnerHeaderComponent
  ],
  imports: [
    CommonModule,
    RouterModule,   
    FormsModule,   
    CollapseModule.forRoot(),
    BsDropdownModule,
     ],
  providers: [],
  exports     : [
    InnerHeaderComponent
  ],
  entryComponents : [InnerHeaderComponent]
})
export class InnerHeaderModule { }
